@use "../../variables" as *;
@use "../../mixins" as *;

.epr-container {
    z-index: 999;
    position: absolute;

    .background {
        background: rgba($grey-text, 0.9);
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
    }

    .panel {
        position: fixed;
        background-color: white;
        top: 0;
        right: 0;
        height: 100vh;
        width: 100%;
        transform: translateX(100%);
        transition: all 350ms ease-out;
        display: flex;
        flex-direction: column;

        @include tablet {
            max-width: 25.5rem;
        }

        &.active {
            transform: translateX(0);
        }

        .separator {
            @include separator-bottom;
        }

        .wrapper {
            padding: 1.5rem;

            .header {
                display: flex;
                justify-content: space-between;
                margin-bottom: 1.5rem;

                .title {
                    font-size: 1.25rem;
                    font-weight: 500;
                }

                .close {
                    width: 1.5rem;
                    height: 1.5rem;
                    cursor: pointer;
                }
            }

            .details {
                display: flex;
                flex-direction: column;

                .label {
                    font-weight: 500;
                    margin-top: 1.5rem;
                    color: inherit;
                }

                ul {
                    margin: 0.25rem 0 0 0;
                    padding-left: 1.125rem;
                    display: flex;
                    flex-direction: column;
                    gap: 0.25rem;
                }

                .dangerous-substance-container {
                    margin-top: 0.25rem;
                    display: flex;
                    gap: 0.25rem;

                    .icon {
                        transform: translate(0, 2px);
                    }
                }

                .metallic-fibre-container {
                    margin-top: 1.5rem;;
                    display: flex;
                    gap: 0.25rem;

                    .icon {
                        transform: translate(0, 2px) scale(1.1);
                    }
                }

                .recycled-container {
                    display: flex;
                    flex-direction: column;
                    gap: 0.25rem;
                }

                .microplastic {
                    margin-top: 1.5rem;
                }
            }
        }

        .footer {
            margin-top: auto;

            .wrapper {
                padding: 1.125rem;
                display: flex;
                justify-content: center;

                .button {
                    background-color: white;
                    border: 1px solid $divider;
                    padding: 0.75rem 1.5rem;
                    cursor: pointer;
                    border-radius: 24px;
                }
            }
        }
    }
}
